// Kajabi destination URLs. Keep CTAs pointing to existing Kajabi pages
export const KAJABI = {
 ebook: "https://join.underground-mix.com/foundationsofsyncsuccessquickstart",
 libraries: "https://join.underground-mix.com/resource_redirect/landing_pages/2151728710",
 access: "https://join.underground-mix.com/resource_redirect/landing_pages/2151678304",
 mastermind: "https://join.underground-mix.com/mastermindapplication",
 camp: "https://join.underground-mix.com/camp",
 immersion: "https://join.underground-mix.com/the-sync-immersion-waitlist",
};

export const PLACEMENT_BRANDS = [
 "WALMART",
 "FOUND (NBC)",
 "EQUALIZER (CBS)",
 "EBAY",
 "AMAZON",
 "SECRET LIVES OF MORMON WIVES",
 "NATIVE PET",
 "AMERICAN IDOL",
 "JERSEY MIKE'S",
 "DR. ODYSSEY",
 "NCIS",
 "CSI. VEGAS",
 "VERIZON",
 "GINNY & GEORGIA",
 "THE CHALLENGE",
 "GROWNISH",
];

export const STATS_MARQUEE = [
 "45+ SYNC PLACEMENTS IN 18 MONTHS",
 "$250K+ CLEARED FOR INDIE CREATORS",
 "NOT A COURSE. AN EXPERIENCE",
 "PREMIUM / NON-LIBRARY RATES",
 "15,000+ CAREER SYNCS BY OUR FOUNDERS",
];

export const TESTIMONIALS = [
 {
 name: "Sherilyn K.",
 role: "Songwriter",
 quote:
 "Underground Mix was a career highlight. Devon's expertise and ability to bring out the best in you is unmatched.",
 },
 {
 name: "Megan Correa · Lil MC",
 role: "Artist / Producer",
 quote:
 "Underground Mix has leveled up my sync game so much. I finally feel like I'm on my way to a financially stable career in this industry.",
 },
 {
 name: "Bill O'Hanlon",
 role: "Author · Co-writer of 2,000+ songs",
 quote:
 "Devon's program offers real feedback, encouragement, and connection with serious musicians. Perfect for committed creators.",
 },
 {
 name: "Anne-Louise S.",
 role: "Mastermind Member",
 quote:
 "In just a few months I've gained knowledge, met amazing creators, and had my music pitched countless times. He helps you find faith in yourself again.",
 },
 {
 name: "Clayton J.",
 role: "Artist",
 quote:
 "The difference in my writing and production is night and day. Especially in sync. Devon's guidance leads to top-level opportunities and lasting relationships.",
 },
 {
 name: "Keahi",
 role: "Underground ACCESS Member",
 quote:
 "A step above. A hands-on and unique deeper dive into the world of sync. Loving it.",
 },
 {
 name: "Bonnie Warren",
 role: "Artist / Songwriter",
 quote:
 "Each meeting is packed with industry insights, creative development, song feedback, and real-time interaction. Underground Mix is the place to be.",
 },
 {
 name: "Anders S.",
 role: "Producer",
 quote:
 "The most impactful part of my music career. The community, sync network, education and mentorship have driven incredible growth.",
 },
];

export const OFFERS = [
 {
 id: "course",
 kicker: "8-Week · Live Immersion",
 title: "The SYNC Immersion",
 tagline: "8 weeks. 8 mini-courses. One full-immersion experience.",
 description:
 "Weekly live meetings. Eight mini-courses that set your sync foundation. ACCESS membership included for the full 8 weeks.",
 cta: "Register Now",
 href: "/course",
 external: false,
 accent: "from-white/10 to-white/[0.02]",
 price: "WAITLIST OPEN",
 comingSoon: true,
 },
 {
 id: "access",
 kicker: "Monthly Membership",
 title: "Underground ACCESS",
 tagline: "Weekly immersion into the legit world of sync.",
 description:
 "Live weekly executive coaching, song critiques, active briefs, and access to a vetted sync community. Monthly tiers from $39 to $149.",
 cta: "Explore Membership",
 href: "/access",
 external: false,
 accent: "from-amber/20 to-amber/0",
 price: "$39–$149 / MO",
 featured: true,
 },
 {
 id: "mastermind",
 kicker: "Application Only",
 title: "Underground Mix Mastermind",
 tagline: "Small-cohort, high-criteria, direct access to Devon & Becki.",
 description:
 "Weekly small-group cohorts. Thousands of pitches. Hundreds of briefs. Placements on Verizon, Walmart, NCIS, Dr. Odyssey, American Idol and more.",
 cta: "Start Application",
 href: "/mastermind",
 external: false,
 accent: "from-amber to-amber-soft",
 price: "5-MONTH COHORT",
 },
 {
 id: "camp",
 kicker: "Virtual · Sync Camp · Est. 2023",
 title: "UM C.A.M.P.",
 tagline: "Collaboration · Access · Music Placement.",
 description:
 "A virtual sync camp where you collaborate with vetted pro producers and writers. With two active music supervisors giving real direction before each day. Where songs stop being 'good ideas' and start being solutions.",
 cta: "Request Info",
 href: "/camp",
 external: false,
 accent: "from-navy-light/30 to-navy/0",
 price: "NEXT DATES TBA",
 },
];

export const FAQS = [
 {
 q: "Can I cancel Underground ACCESS at any time?",
 a: "Underground ACCESS is a 6-month commitment. Because the real power of ACCESS is community, collaboration, live critique and relationship with supervisors. This only fully lands when you're in the room consistently over time. After the 6 months, you are free to reach out and cancel your membership.",
 },
 {
 q: "Do you take ownership of my copyrights or masters?",
 a: "No. We do not assume any ownership of your material when you join. If we choose to represent a song of yours for sync licensing, we only commission on the front-end license and never on back-end performance royalties.",
 },
 {
 q: "Are results guaranteed?",
 a: "There are no guarantees in sync licensing. Your results depend on your craft and your willingness to execute what we teach. If we agree to represent your song, it will be heard by the right people. But no one can promise a license.",
 },
 {
 q: "Do you pitch every song I submit?",
 a: "No. Your membership fee is an investment in your craft, insider education, and executive coaching. Once inside, you can pitch us one song per month for consideration. Plus one song per active brief we share.",
 },
 {
 q: "How do I get into the Mastermind?",
 a: "Acceptance is by application and a Zoom interview if you're shortlisted. We only select a small group of songwriters, artists and producers who are a real fit for a 5-month cohort.",
 },
];

export const ACCESS_TIERS = [
 {
 name: "ACCESS",
 price: "$39",
 period: "/ month",
 tagline: "Start here. Get inside the community.",
 checkoutUrl: "https://join.underground-mix.com/offers/K2YaPZde/checkout",
 features: [
 "Pre-recorded coaching content",
 "1 active brief / month",
 "Monthly virtual Office Hours Zoom call",
 "C.A.M.P., mini-course & e-book discounts",
 ],
 featured: false,
 },
 {
 name: "ACCESS PLUS",
 price: "$97",
 period: "/ month",
 tagline: "Get your music in the critique rotation.",
 checkoutUrl: "https://join.underground-mix.com/offers/UMxyFsns/checkout",
 features: [
 "Everything in ACCESS",
 "Weekly 1-hour live session. Thursdays",
 "Recorded replays sent if you miss a meeting",
 "Submit 1 song / month for live critique",
 "5 active briefs / month",
 "50% off C.A.M.P. registration",
 "Potential UM representation of submitted songs",
 "20 AI sync bot questions / quarter",
 "6-month minimum commitment",
 ],
 featured: true,
 },
 {
 name: "ACCESS PREMIUM",
 price: "$149",
 period: "/ month",
 tagline: "Deeper immersion, deeper access.",
 checkoutUrl: "https://join.underground-mix.com/offers/5C4mp642/checkout",
 features: [
 "Everything in ACCESS PLUS",
 "Recorded replays sent if you miss a meeting",
 "1:1 call every 6 months",
 "Additional email feedback on a song each month",
 "Priority on briefs & pitch opportunities",
 "Expanded executive feedback on submissions",
 "30 AI sync bot questions / quarter",
 "6-month minimum commitment",
 ],
 featured: false,
 },
];

export const TRACKS = [
 { title: "Take It Up A Notch", artist: "JF", tag: "The Bus Music / Underground Mix" },
 { title: "Black Lagoon", artist: "Wilkes", tag: "The Bus Music / Underground Mix" },
 { title: "Lookin For Me", artist: "Lil MC", tag: "The Bus Music" },
 { title: "I Want To Be Your Secret", artist: "Hannah Jai", tag: "The Bus Music / Underground Mix" },
 { title: "Best Days", artist: "Wilkes", tag: "The Bus Music / Underground Mix" },
 { title: "Making Fire", artist: "Nathan Dunton", tag: "The Bus Music" },
 { title: "Hang It Up", artist: "James & the Wild Spirit", tag: "The Bus Music / Underground Mix" },
 { title: "Boss Moves Only", artist: "Alyssa Degati", tag: "The Bus Music / Underground Mix" },
];

// Portrait URLs. Use locally generated AI-enhanced if available, fallback to originals
export const PORTRAITS = {
 devon: {
 enhanced: "/devon.png",
 fallback:
 "https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2163536441/settings_images/cdd177-cadd-1610-ca6-3e65587db2fe_c36b7c91-97c7-4586-96aa-f47db96af2db.png",
 },
 becki: {
 enhanced: "/becki.png",
 fallback:
 "https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production//sites/2148507639/images/075771dd-9e76-4948-b331-00f43094e7be.png",
 },
};

export const HERO_VIDEO_POSTER =
 "https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2158424428/settings_images/a51ff1e-e542-f8-4c78-42d25d2115a_Devon_12_.png";

export const SECONDARY_VIDEO_POSTER =
 "https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2158424428/settings_images/5cf1b8-0781-0311-84c8-f5d877ce64_devon_ONE-3.png";

export const STUDIO_BG =
 "https://images.unsplash.com/photo-1748698535024-e246f0da88dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxtdXNpYyUyMHN0dWRpbyUyMG1peGluZyUyMGNvbnNvbGUlMjBkYXJrfGVufDB8fHx8MTc3NjU1NjcwMHww&ixlib=rb-4.1.0&q=85";

export const CONCERT_BG =
 "https://images.unsplash.com/photo-1773687064765-84ddf838b605?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxsaXZlJTIwY29uY2VydCUyMGNyb3dkJTIwc2lsaG91ZXR0ZXxlbnwwfHx8fDE3NzY1NTY3MDB8MA&ixlib=rb-4.1.0&q=85";
